var map = {
	"./demoinsurance/piattaforma-prodotti/database/ProtezionePersona.vue": [
		"99da",
		"configuration~configuration0~configuration1~configuration2",
		"configuration0"
	],
	"./global/piattaforma-prodotti/database/ProtezionePersona.vue": [
		"e022",
		"configuration~configuration0~configuration1~configuration2",
		"configuration1~configuration2",
		"configuration1"
	],
	"./shdev/piattaforma-prodotti/database/ProtezionePersona.vue": [
		"c467",
		"configuration~configuration0~configuration1~configuration2",
		"configuration1~configuration2",
		"configuration2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0899";
module.exports = webpackAsyncContext;